import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
import axios from "axios";

const Footer = () => {
   const { Headers, isHeader, cartItems, AllProducts, AllCategoriess } =
     useBlogContext();

  return (
    <>
      <footer>
  <div className="footer-top">
    <div className="container">
      <div className="row">
      
      {isHeader
  ? // Display loading skeletons while data is being fetched
    Array.from({ length: 4 }).map((_, index) => (
      <div className="col-md-6 col-xl-2" key={index}>
        <div className="footer-widget">
          <div
            className="skeleton mb-4"
            style={{ height: 24, width: 100, borderRadius: 5 }}
          ></div>
          <ul className="footer-menu">
            {Array.from({ length: 3 }).map((__, i) => (
              <li key={i}>
                <div
                  className="skeleton mt-1"
                  style={{ height: 20, width: 80, borderRadius: 5 }}
                ></div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ))
  : Headers.footer !== undefined &&
    Headers.footer.slice(0, 4).map((item, index) => (
      <div className="col-md-6 col-xl-3" key={index}>
        <div className="footer-widget">
          <h5 className="mb-4">{item.text}</h5>
          <ul className="footer-menu">
            {item.children.map((childItem, childIndex) => (
              <li key={childIndex}>
                <Link to={childItem.link}>
                  {childItem.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ))}

        {/* <div className="col-md-12 col-xl-4">
          <div className="footer-widget">
            <div className="card bg-light-200 border-0 mb-3">
              <div className="card-body">
                <h5 className="mb-3">SignUp For Subscription</h5>
                <form id="subscriberForm" autoComplete="off">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="subscriber_email"
                      id="subscriber_email"
                      placeholder="Enter Email"
                    />
                    <span
                      className="text-danger error-text"
                      id="subscriber_email_error"
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-lg btn-linear-primary w-100"
                    id="subscriberBtn"
                  >
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
            <div className="d-flex align-items-center ">
              <h6 className="fs-14 fw-normal me-2">Download Our App</h6>
              <img
                src="/front/img/icons/app-store.svg"
                className="me-2"
                alt="img"
              />
              <img
                src="/front/img/icons/goolge-play.svg"
                className="me-2"
                alt="img"
              />
            </div>
          </div>
        </div> */}

      </div>
    </div>
  </div>
  <div className="footer-bottom">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div>
              <p className="mb-2 text-start" 
                title="https://seotowebdesign.com/" >

                  {!isHeader && Headers.footer_credit}{" "}| Design by{" "}
                  <a href="https://seotowebdesign.com/" target="blank" className="text-dark ">
                    Seo To Webdesign{" "}
                  </a>
                  
                </p>
                
              
            </div>
            {/* <ul className="menu-links mb-2">
              <li>
                <a href="/terms-conditions">
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href="/privacy-policy">
                  Privacy Policy
                </a>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

    </>
  );
};

export default Footer;
